import { ref, reactive } from 'vue';
export default {
  name: 'FResult',
  components: {},
  setup(props, context) {
    const IsShow = ref(false);
    const DMConfig = reactive({
      loading: false,
      Columns: [{
        title: "序号",
        width: 70,
        align: 'center',
        key: 'serial'
      }, {
        title: '单据编号',
        dataIndex: 'FBillNo',
        width: 250
      }, {
        title: '操作状态',
        dataIndex: 'FState'
      }],
      Results: []
    });
    const SubmitForm = e => {
      IsShow.value = false;
      context.emit('ok');
    };
    const Open = Results => {
      IsShow.value = true;
      DMConfig.Results = Results;
    };
    return {
      IsShow,
      Open,
      DMConfig,
      SubmitForm
    };
  },
  created() {},
  mounted() {},
  methods: {}
};